export default [
    {
        'text': 'New IC',
        'value': 1
    },
    {
        'text': 'Old IC',
        'value': 2
    },
    {
        'text': 'Army',
        'value': 3
    },
    {
        'text': 'Police',
        'value': 4
    },
    {
        'text': 'Passport',
        'value': 5
    }
];
